module.exports = __webpack_public_path__ + "static/media/Duan3.617ce817.png";